import { PatientListScreen } from "~/session/patient-list/patient-list-screen";

// Index of /session/:id — the session's patient list (E5.1), grouped by priority
// and searchable. The shared screen loads the list and resolves the outgoing-
// doctor action bar; it renders inside <SessionLayout>, which provides the
// session via context.
export default function SessionPatientsRoute(): JSX.Element {
  return <PatientListScreen />;
}
